import { motion, useAnimation } from 'framer-motion';
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import newAccount from './img/Add_user.svg';
import deal from './img/business_deal.svg';
import cash from './img/coin-cash.svg';

export default function Start() {
  const control = useAnimation();
  const [boxRef, boxInView] = useInView({
    rootMargin: '-50px 0px'
  })

  const hoverEffect = {
    whileHover: { scale: 1.1, color: 'rgb(59, 194, 149)' },
    whileTap: { scale: 0.9 }
  }

  const boxVariant = {
    hidden: {
      x: '-50vw', opacity: 0
    },
    visible: {
      x: 0, opacity: 1,
      transition: {
        when: 'beforeChildren',
        // duration: 0.5,
        // type: 'spring',
        // stiffness: 500,
        // damping: 10,
        staggerChildren: 0.3
      }
    }
  }

  const childVariant = {
    hidden: {
      opacity: 0,
      y: -40
    },
    visible: {
      y: 0,
      opacity: 1,
    }
  }

  useEffect(() => {
    if(boxInView) { control.start('visible') }
    if (!boxInView) { control.start('hidden') }
  }, [control, {boxRef, boxInView}]);

  return (
    <>
      <motion.div
      ref={boxRef}
      variants={boxVariant}
      animate={control}
      initial="hidden"

      >
        <h2>Get started in three easy steps</h2>
        <div className="getStarted-steps">
          <motion.a
            href="https://ideypay.com/signup"
            className="getStarted-actions"
            variants={childVariant}
            {...hoverEffect}
          >
            <img src={newAccount} alt="sign-up" className="getStarted-img" />
            <h3>Create a free account</h3>
          </motion.a>
          <motion.a variants={childVariant} {...hoverEffect} className="getStarted-actions">
            <img src={deal} alt="trade" className="getStarted-img" />
            <h3>Trade</h3>
          </motion.a>
          <motion.a variants={childVariant} {...hoverEffect} className="getStarted-actions">
            <img src={cash} alt="earn" className="getStarted-img" style={{ transform: 'scale(0.8)'}} />
            <h3>Earn</h3>
          </motion.a>
        </div>
      </motion.div>
    </>
  )
}
